import { Fragment, h } from 'preact';
import { Route } from 'libs/router';
import { routes } from 'features/verify/routes';
import { InvalidSession } from './invalid-session';
import { Unhandled } from './unhandled';
import { AccessDeclined } from './access-declined';
import { AccessDenied } from './access-denied';
import { PoorCameraQuality } from './poor-camera-quality';
import { CameraError } from './camera-error';

export const VerificationError = () => {
	return (
		<Fragment>
			<Route path={routes.error.unhandled} component={<Unhandled/>}/>
			<Route path={routes.error.invalidSession} component={<InvalidSession/>}/>
			<Route path={routes.error.cameraAccessDeclined} component={<AccessDeclined/>}/>
			<Route path={routes.error.cameraAccessDenied} component={<AccessDenied/>}/>
			<Route path={routes.error.cameraError} component={<CameraError/>}/>
			<Route path={routes.error.poorCameraQuality} component={<PoorCameraQuality/>}/>
		</Fragment>
	);
};
